<div [className]="classDiv">
  <h6 *ngIf="!!title" class="fw-bold {{ classTitle }}" [innerHTML]="title"></h6>
  <br *ngIf="!!br" />
  <p *ngIf="!!desc" class="{{ classDesc }}" [innerHTML]="desc"></p>
</div>
